module.exports = __webpack_public_path__ + "img/measure.214566e.png";